<template>
 <div class="row py-lg-7 py-5"> 
   <div class="col-48" v-for="service in item" :key="service.id">
     <div class="row px-3 mb-lg-0 mb-5">
       <div class="col-lg-24 col-48 fw-bold text-primary single-service-title text-start">{{service.name}}</div>
       <div class="col-lg-24 col-48 text-lg-end text-start">
          <button type="button" @click="hasHistory() 
    ? $router.go(-1) 
    : $router.push('/')" class="my-3 back-results-btn">
                    Back to Results
                  </button></div></div></div> 
      
<div id="showresults" class="col-lg-24 col-48 px-lg-0 px-3">
  <div class="Single Item col-48 text-start single-border-shadow">
    
 <div v-for="service in item" :key="service.id" class="side-list px-3">
<div v-if="service.image" class="single-service-img mb-5"><a v-if="service.website" class="" target="_blank" :href="service.website"><img :alt="service.name+' Logo'" :src="service.image"><span class="screen-reader-only">(opens in a new tab)</span></a><img v-else :alt="service.name+' Logo'" :src="service.image"></div>
<div v-else class="pb-5"></div>
 <div class="card-body px-lg-5 px-0 py-0 text-start">
   <div class="titles mb-4">
      <a v-if="service.website" class="text-decoration-none" target="_blank" :href="service.website"><h4 class="card-title fw-bold ">{{service.name}}</h4><span class="screen-reader-only">(opens in a new tab)</span></a>
      <h4 v-else class="card-title fw-bold ">{{service.name}}</h4>
      <h5 v-if="service.subName" class="card-title fw-bold mb-4">{{service.subName}}</h5>
   </div>
                 
                  <p class="card-text fw-light lh-13">{{service.overview}}</p>
                  
<div class="mb-5" v-if="service.entryRequirements" >
                  <h4 class="fw-bold mb-4">Entry Requirements</h4>
                  <p class="card-text fw-light lh-13">{{service.entryRequirements}}</p>
                  </div>
<div class="mb-5" v-if="service.clinicalServices">
                  <h4 class="fw-bold mb-4">Clinical Services</h4>
                  <p v-if="service.clinicalServiceIntro">{{service.clinicalServiceIntro}}</p>
                  <ul class="card-text fw-light lh-13 ps-3"><li v-for="iteme in service.clinicalServices" :key="iteme">{{iteme}}</li></ul>
                
                  </div>
<div class="mb-5" v-if="service.targetGroup">
  <h4 class="fw-bold mb-4 target-group-title">Target Groups</h4>
                  <div  class="item-holder card-text fw-light lh-13"><p v-for="item in service.targetGroup" :key="item">{{item}}</p></div>
                  </div>
<div class="mb-5" v-if="service.certifications">
                    <h4 class="fw-bold mb-4">Certifications</h4>
                  <p class="card-text fw-light lh-13">{{service.certifications}}</p>
                  </div>
                 
                </div>
                                <div class="card-footer bg-transparent border-0  d-flex align-items-center justify-content-end flex-row p-3">


              
                </div>
   </div>
   </div>
   </div>
         <div class="col-lg-24 col-48 gx-5 singleMap">
        <GMapMap :key="index" v-for="(m, index) in item" :center="{lat: m.newlat, lng: m.newlng}" :zoom="14"  :options="mapStyle">
          
            <GMapMarker :key="index" v-for="(m, index) in item" :position="{lat:Number(m.newlat),lng: Number(m.newlng )}" :clickable="true"
              :draggable="true" @click="center = m.position" :icon="mapMarker" />
          


        </GMapMap>

        <div class="row py-5 px-3 single-details-row" v-for="service in item" :key="service.id">
          <div class="col-48 text-start mb-5">
            <div class="d-flex align-items-lg-center align-items-start justify-content-between flex-column flex-lg-row mb-4">
             <h4 class="text-start fw-bold mb-0">This service offers</h4>
             <div class="btn btn-primary border-0 bg-transparent text-primary px-0" @click="printWindow()"><u>Print Page</u></div></div>

             <div class="d-inline-block position-relative" :key="item" v-for="(item, index) in service.categoriesValue" :class="{ active: show === index }"
        @mouseover="show = index;"
        @mouseout="show = false;">
                <img class="cat-icons-single me-2"  :alt="item" :src="baseURL  + item +'.png'">
                   <transition name="fade">
          <div class="single-tooltip text-capitalize" v-if="show === index">{{ item.replace(/-/g, ' ').toLowerCase() }}</div>
        </transition>
             </div>
          </div>
          <div class="col-48 mb-5">
            <div class="row">

           
          <div class="col-md-24 col-48 text-start">
            <div class="mb-5" v-if="service.postcode">
            <h6 class="text-start fw-bold text-dgreen">Address</h6>
                 <div class="address-details" v-if="service.street !== '' && service.suburb !== ''"> <a :href="'https://www.google.com/maps/place/'+ service.street.replace(/\s+/g, '+').toLowerCase() + ',' + service.suburb +''">
             <div class="address-details-street" v-if="service.street">{{service.street}}</div>
             <div class="address-details-suburb" v-if="service.suburb">{{service.suburb}}</div>
             <div class="address-details-postcode" v-if="service.state">{{service.state}}<span v-if="service.postcode"></span>, {{service.postcode}}</div>
             </a> 
           </div>
          <div v-else class="address-details"> 
             <div class="address-details-street" v-if="service.street">{{service.street}}</div>
             <div class="address-details-suburb" v-if="service.suburb">{{service.suburb}}</div>
             <div class="address-details-postcode" v-if="service.state">{{service.state}}<span v-if="service.postcode"></span>, {{service.postcode}}</div>
           </div>
      </div>
                <div class="mb-5" v-if="service.poPostcode">
            <h6 class="text-start fw-bold text-dgreen">Postal Address</h6>
        <div class="address-details"> 
             <div class="address-details-street" v-if="service.poBox">{{service.poBox}}</div>
             <div class="address-details-suburb" v-if="service.poSuburb">{{service.poSuburb}}</div>
             <div class="address-details-postcode" v-if="service.poState">{{service.poState}}<span v-if="service.poPostcode">, {{service.poPostcode}}</span></div>
           </div>
      </div>
                   <div class="mb-5" v-if="service.openingHours">
            <h6 class="text-start fw-bold text-dgreen">Opening Hours</h6>
        <div class="address-details"> 
             <div class="address-details-street" v-if="service.openingHours">{{service.openingHours}}</div>
           </div>
      </div>
          </div>
          <div class="col-md-24 col-48 text-start">
            <div class="mb-5" v-if="service.phone1">
 <h6 class=" fw-bold text-dgreen">Contact Numbers</h6>
               <div class="overview mb-2"> <a class="overview mb-2" :href="`tel:` + service.phone1">{{service.phone1}}</a> <span v-if="service.phone1Detail" class="">({{service.phone1Detail}})</span></div>
                <div class="overview "> <a class="overview mb-2" :href="`tel:` + service.phone2">{{service.phone2}}</a> <span v-if="service.phone1Detai2">({{service.phone2Detail}})</span></div>
            </div>
           <div v-if="service.email">
 <h6 class=" fw-bold text-dgreen">Email Address</h6>
               <a class="overview mb-2" :href="`mailto:` + service.email">{{service.email}}</a>
            </div>
    
          </div>
           </div>
          </div>
          <div class="col-48">
            <div class="row">
    <div v-if="service.website" class="col-lg-24 col-48 pe-lg-7 pe-0">
      <a  class="filter-btn btn" alt="Visit Website Button" target="_blank" :href="service.website">Visit Website <span class="screen-reader-only">(opens in a new tab)</span></a>
    </div>
    <div  v-if="service.phone1" class="col-lg-24 col-48 pe-lg-7 pe-0">
      <a class="filter-reset-btn btn" alt="Call Service Button" :href="`tel:` + service.phone1">Call Service</a>
    </div>
  </div>
  </div>
        </div>

      </div>
       </div>
</template>

<script>

export default {
 props: ['item'],
  data () {
    let mapMarker ='https://wanada.org.au/wp-content/themes/wanada-child/img/marker.png';
      return {
        mapMarker,
         baseURL:'https://wanada.org.au/wp-content/themes/wanada-child/img/',
          center: {
          lat: 51.093048,
          lng: 6.842120
        },
        mapStyle: {
          draggable: true,
          zoomControl: false,
          mapTypeControl: false,
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          animation: 2,
          disableDefaultUI: true,
          styles:[{featureType:"water",elementType:"geometry",stylers:[{color:"#e9e9e9"},{lightness:17}]},{featureType:"landscape",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:20}]},{featureType:"road.highway",elementType:"geometry.fill",stylers:[{color:"#ffffff"},{lightness:17}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#ffffff"},{lightness:29},{weight:0.2}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:18}]},{featureType:"road.local",elementType:"geometry",stylers:[{color:"#ffffff"},{lightness:16}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#f5f5f5"},{lightness:21}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#dedede"},{lightness:21}]},{elementType:"labels.text.stroke",stylers:[{visibility:"on"},{color:"#ffffff"},{lightness:16}]},{elementType:"labels.text.fill",stylers:[{saturation:36},{color:"#333333"},{lightness:40}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#f2f2f2"},{lightness:19}]},{featureType:"administrative",elementType:"geometry.fill",stylers:[{color:"#fefefe"},{lightness:20}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#fefefe"},{lightness:17},{weight:1.2}]}]
        },
        pategory: '',
        name: '',
        range: '1000',
        fService: [],
        services: [],
        show: false,
      }
    },
    methods: {

      printWindow: function () {		
	 window.print();
    },

      filterProductsByName: function () {
        return this.filteredItems.filter( ( service ) => {
          return service.title.toLowerCase().match( this.name );
        } );

      },
      hasHistory () {
        return window.history.length > 2
      }
    },
}
</script>

<style lang="scss">
// @import '@/assets/app.scss';
</style>
